import { DATABASE_BE_STREAMING_PARTICIPANT } from '@databases/database-ai-first-creation-state';
import { presenceState } from '@databases/presence';
import { useEffect } from 'react';

export function useBackendAgentEntryPresence(entryId: string | undefined): void {
  useEffect(() => {
    if (!entryId) {
      return;
    }

    presenceState.addParticipant({ entryId }, DATABASE_BE_STREAMING_PARTICIPANT);
    return () => presenceState.removeParticipant(DATABASE_BE_STREAMING_PARTICIPANT);
  }, [entryId]);
}
